import { render } from "./licenseTier.vue?vue&type=template&id=4d054cea&scoped=true"
import script from "./licenseTier.vue?vue&type=script&lang=js"
export * from "./licenseTier.vue?vue&type=script&lang=js"

import "./licenseTier.vue?vue&type=style&index=0&id=4d054cea&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d054cea"]])

export default __exports__